import "core-js/modules/es6.regexp.replace";
import _typeof from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

var RouterPlugin = function RouterPlugin() {
  this.$router = null;
  this.$store = null;
};

RouterPlugin.install = function (vue, router, store, i18n) {
  var _this = this;

  this.$router = router;
  this.$store = store;
  this.$vue = new vue({
    i18n: i18n
  }); // 这个的作用是 为了检查出网页链接，因为本项目用到了 iframe

  function isURL(s) {
    if (s.includes('html')) return true;
    return /^http[s]?:\/\/.*/.test(s);
  } // 将参数处理为参数的形式拼接


  function objToform(obj) {
    var result = [];
    Object.keys(obj).forEach(function (ele) {
      result.push("".concat(ele, "=").concat(obj[ele]));
    });
    return result.join('&');
  }

  this.$router.$avueRouter = {
    //全局配置
    $website: this.$store.getters.website,
    routerList: [],
    group: '',
    meta: {},
    safe: this,
    // 设置标题
    setTitle: function setTitle(title) {
      var defaultTitle = _this.$vue.$t('title');

      title = title ? "".concat(title, "-").concat(defaultTitle) : defaultTitle;
      document.title = title;
    },
    closeTag: function closeTag(value) {
      var tag = value || _this.$store.getters.tag;

      if (typeof value === 'string') {
        tag = _this.$store.getters.tagList.filter(function (ele) {
          return ele.value === value;
        })[0];
      }

      _this.$store.commit('DEL_TAG', tag);
    },
    generateTitle: function generateTitle(title, key) {
      if (!key) return title;

      var hasKey = _this.$vue.$te('route.' + key);

      if (hasKey) {
        // $t :this method from vue-i18n, inject in @/lang/index.js
        var translatedTitle = _this.$vue.$t('route.' + key);

        return translatedTitle;
      }

      return title;
    },
    //处理路由
    getPath: function getPath(params) {
      var src = params.src;
      var result = src || '/';

      if (isURL(src)) {
        result = "/myiframe/urlPath?".concat(objToform(params));
      }

      return result;
    },
    //正则处理路由
    vaildPath: function vaildPath(list, path) {
      var result = false;
      list.forEach(function (ele) {
        if (new RegExp("^" + ele + ".*", "g").test(path)) {
          result = true;
        }
      });
      return result;
    },
    //设置路由值
    getValue: function getValue(route) {
      var value = "";

      if (route.query.src) {
        value = route.query.src;
      } else {
        value = route.path;
      }

      return value;
    },
    //动态路由
    // 路由是专门的一个接口获取

    /**
     * aMenu: 接受到的动态路由数据 menu的结构外层有父级path 里面有一个childen 记录页面的路由
     * first: 为了区分外界 调用formatRoutes 和 当前文件调用 formatRoutes
    */
    formatRoutes: function formatRoutes() {
      var _this2 = this;

      var aMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var first = arguments.length > 1 ? arguments[1] : undefined;
      // window.console.log('aMenu')
      // window.console.log(aMenu)
      var aRouter = []; // 获取到全局配置中的 props

      var propsConfig = this.$website.menu.props; // 设置 props默认值 作用就是将字段设置成配置的

      var propsDefault = {
        label: propsConfig.label || 'name',
        path: propsConfig.path || 'path',
        icon: propsConfig.icon || 'icon',
        children: propsConfig.children || 'children',
        meta: propsConfig.meta || 'meta'
      }; // 如果没有权限菜单就结束

      if (aMenu.length === 0) return; // 开始处理menu

      var _loop = function _loop(i) {
        // 取到当前要处理的一项
        var oMenu = aMenu[i]; // 判断this.routerList中是否已经存在该path，存在就跳出

        if (_this2.routerList.includes(oMenu[propsDefault.path])) return {
          v: void 0
        }; // 这一块的赋值 也就是取到返回的值

        var path = function () {
          if (first) {
            // 将 '/index' 替换为 ''
            return oMenu[propsDefault.path].replace('/index', '');
          } else {
            return oMenu[propsDefault.path];
          }
        }(),
            //特殊处理组件 执行完这个 component 也就是精确到具体的文件了  views文件夹下面就是具体的页面代码
        _component = 'views' + oMenu.path,
            name = oMenu[propsDefault.label],
            icon = oMenu[propsDefault.icon],
            children = oMenu[propsDefault.children],
            meta = oMenu[propsDefault.meta] || {}; // meta中 keepalive 的处理


        meta = Object.assign(meta, function () {
          if (meta.keepAlive === true) {
            return {
              $keepAlive: true
            };
          }
        }()); //是否有子路由

        var isChild = children.length !== 0;
        var oRouter = {
          path: path,
          component: function component(resolve) {
            // 判断是否为首路由
            if (first) {
              require(['../page/index'], resolve);

              return; // 判断是否为多层路由
            } else if (isChild && !first) {
              require(['../page/index/layout'], resolve);

              return; // 判断是否为最终的页面视图
            } else {
              require(["../".concat(_component, ".vue")], resolve);
            }
          },
          name: name,
          icon: icon,
          meta: meta,
          redirect: function () {
            // 第一次进来但是没有子路由的 需要添加redirect
            if (!isChild && first && !isURL(path)) return "".concat(path, "/index");else return '';
          }(),
          // 整理子路由的route 配置
          // 处理是否为一级路由
          children: !isChild ? function () {
            if (first) {
              // 这里的isURL判断，因为这个网站有使用 iframe。所以需要判断是否为网页链接
              if (!isURL(path)) oMenu[propsDefault.path] = "".concat(path, "/index");
              return [{
                component: function component(resolve) {
                  require(["../".concat(_component, ".vue")], resolve);
                },
                icon: icon,
                name: name,
                meta: meta,
                path: 'index'
              }];
            }

            return [];
          }() : function () {
            /**
             * 这里是重点，当有子路由的时候 会再去执行 formatRoutes 方法，然后又会有一个新的 aMenu for循环。
             * 最后返回的是一个数组 aRouter 这个数组就会作为 childen的值被 return
            */
            return _this2.formatRoutes(children, false);
          }()
        };
        aRouter.push(oRouter);
      };

      for (var i = 0; i < aMenu.length; i++) {
        var _ret = _loop(i);

        if (_typeof(_ret) === "object") return _ret.v;
      } // for循环结束
      // 这个first 卡的其实就是首路由


      if (first) {
        window.console.log(aRouter);

        if (!this.routerList.includes(aRouter[0][propsDefault.path])) {
          this.safe.$router.addRoutes(aRouter);
          this.routerList.push(aRouter[0][propsDefault.path]);
        }
      } else {
        // 这里返回的是子组件
        return aRouter;
      }
    }
  };
};

export default RouterPlugin;